/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
      this.isDragging = false;
      this.hasDragged = false;
    }
    connectedCallback() {
      this.scroller = this.querySelector('.gallery--inner');
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--item .gallery--video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item) => {
        const video = item.querySelector('video');
        if (video) video.play();
      });

      this.setHoverPlayList();
      this.setAnimations();

      if (this.classList.contains('swipe-on-mobile')) {
        this.enableDragScroll();
      }

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:section:load', () => {
          this.setAnimations();
          setTimeout(() => {
            if (window.ScrollTrigger) ScrollTrigger.refresh();
          }, 100);
        });
      }
    }

    setHoverPlayList() {
      this.hoverPlayList.forEach((item) => {
        const video = item.querySelector('video');
        if (!video) return;
        video.currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      const video = videoContainer.querySelector('video');
      if (video) video.play();
    }
    pauseVideo(videoContainer) {
      const video = videoContainer.querySelector('video');
      if (video) video.pause();
    }

    enableDragScroll() {
      const scroller = this.scroller;
      if (!scroller) return;

      let startX = 0;
      let startScrollLeft = 0;

      const isSwipeActive = () =>
        this.classList.contains('swipe-on-mobile') && window.matchMedia('(max-width: 767px)').matches;

      scroller.addEventListener('pointerdown', (event) => {
        if (!isSwipeActive()) return;
        if (event.pointerType === 'touch' || event.button !== 0) return;

        this.isDragging = true;
        this.hasDragged = false;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);

        if (event.target.closest('img, a, figure')) {
          event.preventDefault();
        }
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!this.isDragging) return;

        const walk = event.clientX - startX;
        if (Math.abs(walk) > 3) {
          this.hasDragged = true;
        }
        scroller.scrollLeft = startScrollLeft - walk;
      });

      const endDrag = () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        scroller.classList.remove('is-dragging');
      };

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('lostpointercapture', endDrag);

      scroller.addEventListener('click', (event) => {
        if (!this.hasDragged) return;
        event.preventDefault();
        event.stopPropagation();
        this.hasDragged = false;
      }, true);
    }

    setAnimations() {
      if (!window.ScrollTrigger || !window.gsap) return;

      ScrollTrigger.batch(this.querySelectorAll('figure'), {
        start: 'top 90%',
        onEnter: (elements) => {
          gsap.to(elements, {
            opacity: 1,
            stagger: 0.15,
            ease: window.theme?.settings?.animation_easing,
          });
        },
      });
    }
  }
  customElements.define('theme-gallery', ThemeGallery);
}
